import React, { useState } from 'react';
import { Link, useNavigate, NavLink } from 'react-router-dom';

import useActions from 'hooks/useActions';
import { logout } from 'actions';
import { HOME, SIGN_IN, SERIES, STATS, MY_ACCOUNT } from 'config/url';
import logo from 'images/logo.svg';
import clsx from 'clsx';

const Navbar = ({logged_in}) => {
  const [open, setOpen] = useState(false);
  return (
  <nav className="navbar otoschool-background" role="navigation" aria-label="main navigation">
    <div className="navar-brand otoschool-brand">
      <a className="navbar-item">
         <img src={logo} width="200" />
      </a>
      <a role="button" className={clsx("navbar-burger", {"is-active": open})} aria-label="menu" aria-expanded={open ? "true": "false"} onClick={() => setOpen(!open)}>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
        <span aria-hidden="true"></span>
      </a>
    </div>
    {logged_in ?
    <LoggedNavar isOpen={open} />
    :
    <AnonymousNavbar isOpen={open} />
    }
  </nav>
  )
}

const AnonymousNavbar = ({isOpen}) => (
  <div className={clsx("navbar-menu otoschool-background", {"is-active": isOpen})}>
    <div className="navbar-start">
      <NavLink to={HOME} className={({isActive}) => clsx("navbar-item", {"is-active": isActive})}>
        Accueil
      </NavLink>
    </div>
    <div className="navbar-end">
      <NavLink to={SIGN_IN} className={({isActive}) => clsx("navbar-item", {"is-active": isActive})}>
        Se connecter
      </NavLink>
    </div>
  </div>
)

const LoggedNavar = ({isOpen}) => {
  const dispatchLogout = useActions(logout);
  const navigate = useNavigate();
  const logoutAction = () => {
    dispatchLogout({onSuccess: () => navigate(HOME)})
  }
  return (
  <div className={clsx("navbar-menu otoschool-background", {"is-active": isOpen})}>
    <div className="navbar-start">
      <NavLink to={SERIES} className={({isActive}) => clsx("navbar-item", {"is-active": isActive})}>
        Séries
      </NavLink>
      <NavLink to={STATS} className={({isActive}) => clsx("navbar-item", {"is-active": isActive})}>
        Statistiques
      </NavLink>
    </div>
    <div className="navbar-end">
      <NavLink to={MY_ACCOUNT} className={({isActive}) => clsx("navbar-item", {"is-active": isActive})}>
        Mon compte
      </NavLink>
      <a href="#" className="navbar-item" onClick={logoutAction}>
        Se déconnecter
      </a>
    </div>
  </div>
  );
}

export default Navbar;